import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { uiRules } from '../store/actions/inventoryManagement/inventoryManagement.action';
import { fetchLoggedInUserData } from '../store/actions/userManagement/userManagement.action';
import {
  getUserData,
  isInCarVertical,
  isObjectEmpty,
  userHasGroup,
} from '../utils/utils';
import { isAllowedTo } from '../modules/permissions/permission.util';
import {
  SHOW_BULK_UPLOAD,
  SHOW_DRIVER_MENU,
  SHOW_LOCATION_MENU,
  SHOW_MASTER_DATA_MENU,
  SHOW_KEY_MANAGEMENT_TAB,
  SHOW_SCHEDULED_TASKS_MENU,
  SHOW_USER_PREFERENCES_TAB,
} from '../modules/permissions/permission.type';
import {
  PANEL_MAIN_MENUS,
  PANEL_MAIN_MENU_ITEMS,
  Country,
} from '../utils/constants/values.constants';
import { Tooltip } from '@progress/kendo-react-tooltip';

const LeftNav = (props) => {
  const dispatch = useDispatch();
  const [showDriverMenu, setShowDriverMenu] = useState(false);
  const [showBulkUploadMenu, setShowBulkUploadMenu] = useState(false);
  const [showBigDealerMenu, setShowBigDealerMenu] = useState(false);

  useEffect(() => {
    if (isObjectEmpty(props.uiRulesData)) {
      const accessToken = localStorage.getItem('accessToken');
      const userData = getUserData();
      if (accessToken && userData) {
        dispatch(uiRules());
        dispatch(fetchLoggedInUserData());
      }
    }
  }, []);

  useEffect(() => {
    setShowDriverMenu(props.uiRulesData?.uiPermissions?.crudDriver);
    setShowBulkUploadMenu(props.uiRulesData?.uiPermissions?.bulkUpload);
    setShowBigDealerMenu(props.uiRulesData?.bigDealerActive);
  }, [props.uiRulesData]);

  if (window.location.href.indexOf('/inventory') > -1) {
    sessionStorage.removeItem('searchLocations');
    sessionStorage.removeItem('searchMasterData');
    sessionStorage.removeItem('searchCity');
    sessionStorage.removeItem('searchState');
    sessionStorage.removeItem('searchZone');
    sessionStorage.removeItem('searchLogisticInventories');
  } else if (window.location.href.indexOf('/location') > -1) {
    sessionStorage.removeItem('searchInventories');
    sessionStorage.removeItem('searchMasterData');
    sessionStorage.removeItem('searchCity');
    sessionStorage.removeItem('searchState');
    sessionStorage.removeItem('searchZone');
    sessionStorage.removeItem('inventoryLocation');
    sessionStorage.removeItem('searchLogisticInventories');
  } else if (window.location.href.indexOf('/masterdata') > -1) {
    sessionStorage.removeItem('searchInventories');
    sessionStorage.removeItem('searchLocations');
    sessionStorage.removeItem('inventoryLocation');
    sessionStorage.removeItem('searchLogisticInventories');
  } else if (window.location.href.indexOf('/logistic') > -1) {
    sessionStorage.removeItem('searchLocations');
    sessionStorage.removeItem('searchMasterData');
    sessionStorage.removeItem('searchCity');
    sessionStorage.removeItem('searchState');
    sessionStorage.removeItem('searchZone');
    sessionStorage.removeItem('searchInventories');
  }
  return (
    <nav id="sidebar">
      <div className="sidebar-header">
        <h3>
          <Link to="/">B2C Admin Panel</Link>
        </h3>
      </div>
      <Tooltip
        openDelay={0}
        position="right"
        anchorElement="target"
        filter={(elem) => elem.hasAttribute('title')}
      >
        <ul className="list-unstyled components">
          {PANEL_MAIN_MENU_ITEMS.map((menu) => {
            let isVisible = false;

            switch (menu.key) {
              case PANEL_MAIN_MENUS.INVENTORY:
                isVisible = props.uiRulesData?.uiPermissions?.inventoryMenu;
                break;
              case PANEL_MAIN_MENUS.LOGISTIC:
                isVisible = props.uiRulesData?.uiPermissions?.logisticMenu;
                break;
              case PANEL_MAIN_MENUS.DRIVER_MANAGEMENT:
                isVisible = !!showDriverMenu && isAllowedTo(SHOW_DRIVER_MENU);
                break;
              case PANEL_MAIN_MENUS.LOCATION:
                isVisible =
                  isAllowedTo(SHOW_LOCATION_MENU) &&
                  props.uiRulesData?.uiPermissions?.masterdataMenu;
                break;
              case PANEL_MAIN_MENUS.MASTER_DATA:
                isVisible =
                  isAllowedTo(SHOW_MASTER_DATA_MENU) &&
                  props.uiRulesData?.uiPermissions?.masterdataMenu;
                break;
              case PANEL_MAIN_MENUS.DOCUMENT_PENDENCY:
                isVisible =
                  isInCarVertical() &&
                  props.uiRulesData?.uiPermissions?.documentsMenu;
                break;
              case PANEL_MAIN_MENUS.BULK_UPLOAD:
                isVisible =
                  !!showBulkUploadMenu && isAllowedTo(SHOW_BULK_UPLOAD);
                break;
              case PANEL_MAIN_MENUS.KEY_MANAGEMENT:
                isVisible = isAllowedTo(SHOW_KEY_MANAGEMENT_TAB);
                break;
              case PANEL_MAIN_MENUS.BIG_DEALER_NETWORK:
                isVisible =
                  !!showBigDealerMenu &&
                  props.uiRulesData?.uiPermissions?.bigDealerMenu;
                break;
              case PANEL_MAIN_MENUS.USER_MANAGEMENT:
                // isVisible =
                //   props.uiRulesData?.uiPermissions?.userManagementMenu;
                isVisible = false;
                break;
              case PANEL_MAIN_MENUS.CONFIGS:
                isVisible = props.uiRulesData?.uiPermissions?.configMenu;
                break;
              case PANEL_MAIN_MENUS.SCHEDULED_TASKS:
                isVisible = isAllowedTo(SHOW_SCHEDULED_TASKS_MENU);
                break;
              case PANEL_MAIN_MENUS.USER_MANAGEMENT_V2:
                isVisible =
                  props.uiRulesData?.uiPermissions?.userManagementMenu;
                break;
              case PANEL_MAIN_MENUS.USER_PREFERENCES:
                isVisible =
                  isAllowedTo(SHOW_USER_PREFERENCES_TAB) &&
                  userHasGroup(['CC_ADMIN']);
                break;
              case PANEL_MAIN_MENUS.CAR_CLEANING_QA:
                isVisible = props.uiRulesData?.uiPermissions?.carCleaningQa;
                break;
              case PANEL_MAIN_MENUS.CAR_CLEANING_HISTORY:
                isVisible =
                  props.uiRulesData?.uiPermissions?.carCleaningHistory;
                break;
              case PANEL_MAIN_MENUS.TRAINING_TUTORIALS:
                isVisible = props.uiRulesData?.uiPermissions?.trainingTutorials;
                break;
              case PANEL_MAIN_MENUS.FASTAG:
                isVisible = true;
                break;
              case PANEL_MAIN_MENUS.ENBD_RSTL:
                isVisible =
                  userHasGroup(['DRAWDOWN_ADMIN']) &&
                  localStorage.getItem('country') === Country.AE;
                break;
              case PANEL_MAIN_MENUS.COUPON_REQUESTS:
                isVisible =
                  userHasGroup(['UAE_CPN_REQ', 'UAE_CPN_APPR']) &&
                  localStorage.getItem('country') === Country.AE;
                break;
              case PANEL_MAIN_MENUS.COUPON_CONFIG_MANAGEMENT:
                isVisible =
                  userHasGroup(['UAE_CPN_APPR']) &&
                  localStorage.getItem('country') === Country.AE;
                break;
              default:
                isVisible = true;
                break;
            }
            if (isVisible) {
              return (
                <li
                  key={menu.key}
                  className={
                    window.location.pathname.indexOf(menu.path) !== -1
                      ? 'active'
                      : ''
                  }
                >
                  <a
                    title={props.collapsed ? menu.title : null}
                    href={menu.path}
                  >
                    <span
                      className={menu.icon}
                      style={{ marginRight: '10px', pointerEvents: 'none' }}
                    />
                    <span className="sidebarItem-text">{menu.title}</span>
                  </a>
                </li>
              );
            }
          })}
        </ul>
      </Tooltip>
      <button className="toggleNavBtn" onClick={props.handleNavCollapse}>
        <i
          className={`k-icon ${
            props.collapsed
              ? 'k-i-arrow-chevron-right'
              : 'k-i-arrow-chevron-left'
          }`}
        ></i>
      </button>
    </nav>
  );
};

const mapStateToProps = (state) => ({
  uiRulesData: state.inventoryManagementReducer.uiRulesData,
});

export default connect(mapStateToProps)(LeftNav);

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
